module.exports = __webpack_public_path__ + "img/icon-entradas-salidas-w.03d97e42.svg";